import { render, staticRenderFns } from "./showCreateHistory.vue?vue&type=template&id=61493919&scoped=true"
import script from "./showCreateHistory.vue?vue&type=script&lang=js"
export * from "./showCreateHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61493919",
  null
  
)

export default component.exports